import { Form as FormBase } from '@unform/web';
import styled from 'styled-components';
import { transparentize } from 'polished';
import { Calendar } from 'react-multi-date-picker';

interface FormGroupProps {
  isPrograma?: boolean;
}
export const Container = styled.div`
  display: flex;
  min-height: 100%; // Preencher toda a tela quando ela é grande
  gap: 1rem; //Espaçamento entre cards
  > div {
    padding: 1rem; //Padding dos cards
    min-height: fit-content; // Criar scroll caso o conteúdo seja maior que a tela
  }
`;

export const FormContent = styled.div`
  height: 100%;
  header {
    padding: 0;
    h3 {
      &:last-of-type {
        text-align: end;
      }
    }
  }
`;

export const Form = styled(FormBase)`
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.85rem;
  section {
    display: flex;
    align-items: center; //Alinhar o text com o botão rede
    justify-content: space-between; // Separar o botão REDE
    margin-bottom: 0.5rem; // Espaçar dos demais campos
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
  }

  // Save button
  > button {
    width: 150px;
    margin: 0 auto;
  }
`;

export const FormGroup = styled.div<FormGroupProps>`
  display: flex;
  gap: 1rem;
  > div {
    &:last-child {
      ${({ isPrograma }) => !isPrograma && `width: -webkit-fill-available;`}
    }
  }
`;

export const View = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  header {
    padding: 0;
    height: 80px;
    > div {
      display: flex;
      align-items: center;
      button {
        margin-left: 1rem;
      }
    }
  }
  section {
    display: flex;
    align-items: center; //Alinhar o text com o botão rede
    justify-content: space-between; // Separar o botão REDE
    margin-bottom: 0.5rem; // Espaçar dos demais campos
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};
  }
  h4 {
    margin-bottom: 1rem;
  }
  footer {
    align-items: flex-end;
    p {
      font-style: italic;
    }
  }
`;
export const Filter = styled.div`
  header {
    align-items: center;
    margin: 1rem 0;
  }
`;
